import dispatcher from '../dispatcher';
import slideScrollStore from '../slide-scroll/slide-scroll.store';

var elementProto = Object.create(HTMLElement.prototype);

var _handleSlides = function() {
	var storeData = slideScrollStore.getData().items['report-slides'];
	var self = this;
	var storeIndex;
	var foundIndex = 0;

	if (!storeData) return;
	if (this._index === storeData.index) return;

	if (storeData.index > 0) {
		this.classList.add('active');
	} else {
		this.classList.remove('active');
	}

	storeIndex = storeData.index;
	this._index = storeData.index;

	Array.prototype.forEach.call(this._items, function(item, index) {
		if (index + 1 <= storeIndex && !item.classList.contains('fake')) {
			foundIndex = index;
		}
	})

	Array.prototype.forEach.call(this._items, function(item, index) {
		if (foundIndex === index) {
			item.classList.add('active');
		} else {
			item.classList.remove('active');
		}
	});

	dispatcher.dispatch({
		type: 'indicator:set-until',
		index: storeIndex - 1
	});
}

var _handleDispathcer = function(e) {
	if (e.type === 'form-response' && e.id === 'report-form') {
		if (e.response.hasOwnProperty('response') && e.response.response !== '') {
			if (e.response.status === 'success') {
				this.classList.add('hidden');
			}
			if (e.response.status === 'error') {
				this.classList.remove('hidden');
			}
		}
	}
	if (e.type === 'form-reset'  && e.id === 'report-form') {
		this.classList.remove('hidden');
	}
}

elementProto.createdCallback = function() {
	this.handleSlides = _handleSlides.bind(this);
	this.handleDispathcer = _handleDispathcer.bind(this);
}
elementProto.attachedCallback = function() {
	this._index = 0;
	this._items = this.getElementsByClassName('item');

	Array.prototype.forEach.call(this._items, function(item, index) {
		item.addEventListener('click', function(e) {
			dispatcher.dispatch({
				type: 'slide-scroll:to',
				id: 'report-slides',
				index: index + 1
			});
		});
	});

	this.handleSlides();
	slideScrollStore.subscribe(this.handleSlides);
	dispatcher.subscribe(this.handleDispathcer);
}
elementProto.detachedCallback = function() {
	slideScrollStore.unsubscribe(this.handleSlides);
	dispatcher.unsubscribe(this.handleDispathcer);
}

document.registerElement('report-controls', {
	prototype: elementProto
});